export const FAQ_QUERY = `Faqs {
    faqCategories(pagination: { page: 1, pageSize: 50 }) {
        data {
            id
            attributes {
                name
                label
                hero_label
                hero_subtitle
                section_title
                section_description
                color
                seq_id
            }
        }
    }
    faqs(pagination: { page: 1, pageSize: 200 }) {
        data {
            id
            attributes {
                question
                answer
                category
                seq_id
            }
        }
    }
}`;
